//在这个文件中根路由 / 必须定义，children可自定义
const _import = require("../_import_" + process.env.NODE_ENV);

const routes = [
  {
    path: "/",
    name: "Login",
    component: _import("Login"),
    meta: {
      parent: 0,
    },
    children: [
	  {
		path: "/proDetail",
		name: "proDetail",
		component: _import("projectIntro/proDetail"),
		meta: {
		  menuName: '项目介绍详情',
		  index: 1, //面包屑顺序
		},
	  },
    ],
  },
];
export default routes;
